<template>
  <base-button class="btn-secondary" text="登録せず利用する" />
</template>

<script>
import BaseButton from '@/views/atoms/BaseButton';

export default {
  name: 'UseAsGuestButton',
  components: {
    BaseButton,
  },
}
</script>
